import React from "react";
import { cn } from "@/lib/utils";
import { HeroNav, type NavigationItem } from "@/components/ui/hero/HeroNav";
import { HeroHeadline } from "@/components/ui/hero/HeroHeadline";
import { BrandExperience } from "@/components/ui/hero/BrandExperience";



interface PulseFitHeroProps {
  logo?: React.ReactNode;
  navigation?: NavigationItem[];
  ctaButton?: { label: string; onClick?: () => void; href?: string };
  title: React.ReactNode;
  subtitle: string;
  primaryAction?: { label: string; onClick?: () => void };
  secondaryAction?: { label: string; href?: string; onClick?: () => void };
  disclaimer?: React.ReactNode;
  socialProof?: { avatars: string[] };
  media?: React.ReactNode;
  className?: string;
  showBrands?: boolean;
  children?: React.ReactNode;
}

export function PulseFitHero({
  logo = "Studio",
  navigation = [],
  ctaButton,
  title,
  subtitle,
  primaryAction,
  secondaryAction,
  disclaimer,
  socialProof,
  media,
  className,
  showBrands = false,
  children,
}: PulseFitHeroProps) {
  return (
    <section
      className={cn(
        "relative isolate flex flex-col overflow-hidden bg-background text-foreground",
        className,
      )}
    >
      {/* Gradient orbs */}
      <div className="pointer-events-none absolute -left-40 -bottom-40 sm:-left-56 sm:-bottom-56 sm:right-auto sm:top-auto h-[420px] w-[420px] sm:h-[720px] sm:w-[720px] rounded-full bg-hero-glow-warm opacity-35 blur-3xl sm:blur-[120px]" />
      <div className="pointer-events-none absolute -right-40 -top-40 sm:-right-56 sm:-top-56 sm:left-auto sm:bottom-auto h-[420px] w-[420px] sm:h-[720px] sm:w-[720px] rounded-full bg-hero-glow-cool opacity-40 blur-3xl sm:blur-[120px]" />

      <HeroNav logo={logo} navigation={navigation} ctaButton={ctaButton} />

      {children ? (
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-1 items-center justify-center px-6 pb-24 pt-12 lg:px-10 lg:pt-20">
          {children}
        </div>
      ) : media ? (
        <div className="relative z-10 mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-0 pb-10 pt-6 sm:pb-14 lg:grid-cols-[11fr_9fr] lg:gap-14 lg:px-10 lg:pt-10">
          <HeroHeadline
            align="left"
            title={title}
            subtitle={subtitle}
            primaryAction={primaryAction}
            secondaryAction={secondaryAction}
            disclaimer={disclaimer}
            socialProof={socialProof}
          />
          <div className="flex flex-col gap-6 px-6 lg:px-0">
            {media}
          </div>
        </div>

      ) : (
        <div className="flex flex-col pb-10 sm:pb-14">
          <HeroHeadline
            title={title}
            subtitle={subtitle}
            primaryAction={primaryAction}
            secondaryAction={secondaryAction}
            disclaimer={disclaimer}
            socialProof={socialProof}
          />
        </div>
      )}

      {showBrands ? <BrandExperience inline /> : null}
    </section>

  );
}
